import {getCoords  as  turfgetCoords} from "@turf/invariant";

export default function getCoords(feature1) {
    return turfgetCoords(feature1);
};
